<template>
  <div class="top">
	 <div class="top-left">
	 	<div
	 	  class="sectitle"
	 	>
	 	  <span>{{ acText }}</span
	 	  >{{ Text }}
	 	  <!-- <div
	 	    v-if="isBorderbottom"
	 	    :style="{ width: borderWidth }"
	 	    class="border_bottom"
	 	  ></div> -->
	 	</div>
	 	
	 	<div class="desc" v-if="descText">{{ descText }}</div>
	 </div>
	 <div class="top-right FontGray" v-if="showmore" @click="$emit('clickmore')">
		更多
		<!-- <i class="el-icon-arrow-right"></i> -->
	 </div>
   
  </div>
</template>

<script>
export default {
  props: {
    Text: String,
    acText: String,
    descText: String,
    isBorderbottom: {
      type: Boolean,
      default: true,
    },
    borderWidth: {
      type: String,
      default: "70px",
    },
	showmore:{
		type:Boolean,
		default:true
	}
  },
  data: () => ({
    bor_bottom: "margin-bottom: 20px;",
  }),
};
</script>

<style lang="scss" scope>
.top {
	display: flex;
	align-items: center;
	justify-content: space-between;
	.top-left{
		display: flex;
		align-items: flex-end;
		margin-bottom: 40px;
		.sectitle {
		  // display: inline-block;
		  font-size: 38px;
		  position: relative;
		  top: 5px;
		  color: #333;
		  > span {
		    color: #0465ea;
			 
		  }
		  .border_bottom {
		    position: absolute;
		    bottom: -24px;
		    left: 50%;
		    transform: translateX(-50%);
		    height: 4px;
		    background-color: #0465ea;
		  }
	}
  
    
  }
.top-right{
	cursor: pointer;
}
  .desc {
    // margin: 22px 0 40px;
    color: #666666;
    font-size: 20px;
	 padding-left: 20px;
  }
}
.el-icon-arrow-right{
	color: #333333;
	font-weight: bold;
}
</style>